/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { classnames as cx, cssUtils, propsUtils } from '@ba-ui-toolkit/utils';
import styles from './Separator.scss';

const separatorClassName = styles.separatorClassName.replace(/"/g, '');
const { cssSize } = cssUtils;
const { sanitize } = propsUtils;

export default class Separator extends Component {
	static propTypes = {
		/** If set to true, it takes all available width */
		fullWidth: PropTypes.bool,
		/** Choose the orientation of separator */
		orientation: PropTypes.oneOf(['horizontal', 'vertical']),
		/** Control the left and right margins (actual margin = 8px * hMargin) */
		hMargin: PropTypes.number,
		/** Class name to be passed to separator */
		className: PropTypes.string,
		/** Style object to be passed as the inline styling */
		style: PropTypes.object,
	};

	static defaultProps = {
		orientation: 'horizontal',
		hMargin: 1,
		className: '',
		style: {},
	};

	render() {
		const { fullWidth, orientation, hMargin, className, style, ...others } = this.props;
		const classNames = cx(`${separatorClassName}`, {
			fullWidth,
			[orientation]: orientation,
		});
		if (fullWidth) {
			console.warn(
				"Warning: 'fullWidth' is going to be deprecated in Sprint 39.1, please use 'hMargin={0}' instead (see RTC 220292)."
			); // eslint-disable-line no-console
		}

		return (
			<div
				{...sanitize(others, Separator)}
				role="separator"
				className={`${classNames} ${className}`}
				style={{
					margin: `0 ${cssSize(hMargin)}px`,
					...style,
				}}
			/>
		);
	}
}
